// extracted by mini-css-extract-plugin
export var info = "staff_section-module--info--4bd14";
export var info_text = "staff_section-module--info_text--40437";
export var name = "staff_section-module--name--cd179";
export var section_staff = "staff_section-module--section_staff--c4cb6";
export var sns_icons = "staff_section-module--sns_icons--b27e4";
export var staff_member = "staff_section-module--staff_member--e8ea5";